export const gitCommit = 'c2a2c22f'
